


























































































































import { store } from "@/store/store";
import { ApiResponse, FormType, UserDataTable, UserFilters, UserRole } from "@/types/types";
import UserCreateModal from "@/components/Modal/User/UserCreateModal.vue";
import UserDeleteModal from "@/components/Modal/User/UserDeleteModal.vue";
import UserMultipleDeleteModal from "@/components/Modal/User/UserMultipleDeleteModal.vue";
import UserSendMailModal from "@/components/Modal/User/UserSendMailModal.vue";
import UserTable from "@/components/Table/User/UserTable.vue";
import TableComplement from "@/components/Table/Complement/TableComplement.vue";
import UserFilter from "@/components/Table/User/UserFilter.vue";
import CardTitle from "@/components/Text/Card/CardTitle.vue";
import Toast from "@/components/Modal/Toast/Toast.vue";
import Vue from "vue";
import { UserActionsTypes } from "@/store/modules/User/types";
import { User } from "@/store/modules/User/interface";
import Csv from "@/plugins/csv";
import Utils from "@/utils/utils";
import { Response_ } from "@/plugins/axios/response";
import { Role } from "@/store/modules/Role/interface";

export default Vue.extend({
  name: "User",
  components: {
    UserTable,
    UserCreateModal,
    UserDeleteModal,
    UserMultipleDeleteModal,
    UserSendMailModal,
    Toast,
    CardTitle,
    UserFilter,
    TableComplement
  },
  data: (): any => {
    return {
      user_data: null,
      dialog_should_be_displayed: false,
      delete_dialog_should_be_displayed: false,
      delete_multiple_dialog_should_be_displayed: false,
      mail_dialog_should_be_displayed: false,
      should_display_toast: false,
      should_display_filter_panel: false,
      toast: { type: "INFO", title: "", content: "" },
      filters: { mail: "", role: "", agence: "" },
      selected: [],
      newRole: null
    };
  },
  methods: {
    onFilterChange(filter_object: UserFilters): void {
      this.filters = filter_object;
    },
    clearSelected(): void {
      this.selected = [];
    },
    onSelectChange(_ids: Array<string>): void {
      this.selected = _ids;
    },
    onClose(): void {
      this.delete_dialog_should_be_displayed = false;
      this.dialog_should_be_displayed = false;
      this.mail_dialog_should_be_displayed = false;
      this.delete_multiple_dialog_should_be_displayed = false;
      this.user_data = null;
    },
    is_actual_user(_id: string) {
      return store.getters.LOGGED_USER?._id !== _id;
    },
    shouldDisplayCreateModal(): void {
      this.dialog_should_be_displayed = true;
    },
    shouldDisplayUpdateModal(user: User): void {
      user = store.getters.USER_BY_ID[user._id];
      if (
        Utils.isLoggedUserAdmin() ||
        (store.getters.ROLE_BY_ID[user.role].name.toUpperCase() !== "ADMIN" &&
          store.getters.LOGGED_USER?._id !== user._id)
      ) {
        this.user_data = store.getters.USER_BY_ID[user._id];
        this.dialog_should_be_displayed = true;
      }
    },
    shouldDisplayDeleteModal(user: User): void {
      this.user_data = store.getters.USER_BY_ID[user._id];
      this.delete_dialog_should_be_displayed = true;
    },
    shouldDisplayMultipleDeleteModal(): void {
      this.delete_multiple_dialog_should_be_displayed = true;
    },
    shouldDisplayMailModal(user: User): void {
      this.user_data = store.getters.USER_BY_ID[user._id];
      this.mail_dialog_should_be_displayed = true;
    },
    shouldDisplayToastNotification(toast_data: any): void {
      this.toast = toast_data;
      this.should_display_toast = true;
      setTimeout(this.shouldCloseToastNotification, 2000);
    },
    shouldCloseToastNotification(): void {
      this.should_display_toast = false;
    },
    shouldDisplayFilterPanel(): void {
      this.should_display_filter_panel = true;
    },
    shouldCloseFilterPanel(): void {
      this.should_display_filter_panel = false;
    },
    async onSave(type: FormType, user_data: any, _id: string | undefined): Promise<Response_> {
      if (type === FormType.CREATE) return await store.dispatch(UserActionsTypes.CREATE_USER, user_data);
      else return await store.dispatch(UserActionsTypes.UPDATE_USER, { user_data: user_data, _id: _id });
    },
    async onDelete(_id: string): Promise<Response_> {
      return await store.dispatch(UserActionsTypes.DELETE_USER, _id);
    },
    async onDeleteMultiple(_ids: Array<string>): Promise<Response_> {
      return await store.dispatch(UserActionsTypes.DELETE_MULTIPLE_USER, _ids);
    },
    async onSendMail(id: string): Promise<boolean> {
      const response = await store.dispatch(UserActionsTypes.SEND_USER_MAIL, id);
      return response === ApiResponse.SUCCESS ? true : false;
    },
    async updateSelectedUsersRole(): Promise<void> {
      const promises = this.selected.map((userId: any) => {
        const user = store.getters.USER_BY_ID[userId];
        return store.dispatch(UserActionsTypes.UPDATE_USER, {
          user_data: { ...user, role: this.newRole },
          _id: userId
        });
      });
      const result = await Promise.all(promises);
      if (result.every((res: any) => res.status === ApiResponse.SUCCESS)) {
        this.newRole = null;
        this.shouldDisplayToastNotification({
          type: "SUCCESS",
          title: "Utilisateur Modifiés",
          content: "les utilisateurs ont été mis à jour avec succès"
        });
      } else {
        this.shouldDisplayToastNotification({
          type: "ERROR",
          title: "Erreur",
          content: "Une erreur est survenue lors de la modification des utilisateurs"
        });
      }
    },
    downloadCsv(): void {
      const selected = this.selected.length === 0 ? store.getters.USER_ALL_ID : this.selected;
      const headers = ["mail", "agence", "role"];
      const content = selected.map((user_id: string) => {
        let user: UserDataTable = { ...store.getters.USER_BY_ID[user_id] };
        user.role = store.getters.ROLE_BY_ID[store.getters.USER_BY_ID[user_id].role].name;
        user.agence = store.getters.AGENCE_BY_ID[store.getters.USER_BY_ID[user_id].agence].name;
        return user;
      });
      const blob = Utils.createCsvBlob(new Csv().FromObjToCsv<UserDataTable>(headers, content));
      Utils.createAndClickHiddenInput(URL.createObjectURL(blob), "users.csv");
    }
  },
  computed: {
    roles(): Array<Role> {
      const logged_user = store.getters.LOGGED_USER;
      let roles = store.getters.ROLE_ALL_ID.map((role) => store.getters.ROLE_BY_ID[role]);
      if (store.getters.ROLE_BY_ID[logged_user?.role as string].name.toUpperCase() !== UserRole.ADMINISTRATOR)
        roles = roles.filter((role) => role.name.toUpperCase() !== UserRole.ADMINISTRATOR);
      roles = roles.filter((role) => role.name.toUpperCase() !== "SYSTEME");
      return roles;
    }
  }
});
